import useTestId from '@ori/testid-generator';
import type { FC, PropsWithChildren } from 'react';

import { useApiConfiguration } from '../../contexts';
import { Label, Root } from './styles';

export const MainButton: FC<PropsWithChildren> = ({ children }) => {
  const { apiConfiguration: { goToBasketUrl } = {} } = useApiConfiguration();
  const { getTestId } = useTestId();

  return (
    <Root
      href={goToBasketUrl}
      data-testid={getTestId('button')}
    >
      <Label noWrap>{children}</Label>
    </Root>
  );
};
